/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/geo.file.type.service.ts                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import * as fromEnums from '../../enums';
import * as fromModels from '../../models';

/**
 * The geo file type service
 */
@Injectable({
    providedIn: 'root'
})
export class GeoFileTypeService {

    /**
     * The constructor
     */
    constructor(private http: HttpClient, private logger: NGXLogger) { }

    /**
     * Get geo file types
     */
    getGeoFileTypes(): Observable<fromModels.GeoFileType[]> {
        this.logger.trace('Get plan types');
        return of(fromEnums.GeoFileTypeEnum.TYPES);
    }



}
